<template>
  <div>
    <p class="loading-txt" v-show="!showButton">Loading. Please Wait</p>
    <button v-show="showButton" v-on:click="sendLoad()">
      Get My Estimate!
    </button>
  </div>
</template>
<script src="https://code.jquery.com/jquery-3.4.1.js"></script>

<script>
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { db, storage } from "../assets/db.js";
import { seter } from "../assets/set.js";

export default {
  name: "estimateButtonMember",
  emits: ["pdfResponse"],
  props: [
    "fenceAdd",
    "isMobile",
    "isTablet",
    "removalCategory",
    "styleImage",
    "fenceImg",
    "multiFences",
    "categoryOfFence",
    "styleOfFence",
    "heightOfFence",
    "colorOfFence",
    "gateStyle",
    "gateWidth",
    "lengths",
    "fencePricing",
    "laborForGate",
    "extraPanelData",
    "removalDbSource",
    "fenceCapStyle",
    "amountOfRemoval",
    "gates",
    "output",
    "header",
    "headerone",
    "fencePhoto",
    "amountOfCorners",
    "capStyle",
    "cornersArray",
    "feetFromZero",
    "amountOfHoles",
    "userData",
  ],
  data() {
    return {
      removalForCategory: 0,
      hardHole: this.extraPanelData["hardHole"],
      pdfToUploadJobnimbus: null,
      linePosts: 0,
      pdfToUpload: null,
      finalPrice: null,
      showButton: false,
      minProfit: 0,
      datAcategoryOfFence: null,
      datAstyleOfFence: null,
      datAheightOfFence: null,
      datAcolorOfFence: null,
      datAgateStyle: null,
      datAgateWidth: null,
      datAlengths: [],
      datAfencePricing: null,
      datAlaborForGate: null,
      datAfenceCapStyle: null,
      datAamountOfRemoval: null,
      datAgates: [],
      datAoutput: null,
      datAheader: null,
      datAheaderone: null,
      datAfencePhoto: null,
      datAamountOfCorners: null,
      datAcapStyle: null,
      datAcornersArray: [],
      datAfeetFromZero: null,
      datAamountOfHoles: null,
      datAuserData: null,
      materialPrice: 0,
      totalMaterialPrice: 0,
      totalLabor: 0,
      grandTotal: 0,
      profitPrice: 0,
      clientRetailPrice: 0,
      standardLaborCharges: 0,
    };
  },
  watch: {
    header() {
      setTimeout(() => {
        this.showButton = true;
      }, 3000);
    },
    showButton() {
      this.getRemovalForCategory();
    },
    fenceAdd() {
      if (this.fenceAdd == true) {
        let newFence = {
          categoryOfFence: this.categoryOfFence,
          styleOfFence: this.styleOfFence,
          heightOfFence: this.heightOfFence,
          colorOfFence: this.colorOfFence,
          gateStyle: this.gateStyle,
          gateWidth: this.gateWidth,
          lengths: this.lengths,
          laborForGate: this.laborForGate,
          amountOfRemoval: this.amountOfRemoval,
          gates: this.gates,
          amountOfCorners: this.amountOfCorners,
          capStyle: this.capStyle,
          cornersArray: this.cornersArray,
          feetFromZero: this.feetFromZero,
          amountOfHoles: this.amountOfHoles,
          styleImage: this.styleImage,
        };

        this.multiFences.push(newFence);

        // get minProfit

        let filterItems = this.multiFences.map(function (elem) {
          return {
            Category: elem.categoryOfFence,
            style: elem.styleOfFence,
            height: elem.heightOfFence,
            Color: elem.colorOfFence,
          };
        });

        let array1 = [];

        filterItems.map((element) => {
          let newFence = this.fencePricing.filter(function (item) {
            for (var key in element) {
              if (item[key] === undefined || item[key] != element[key])
                return false;
            }
            return true;
          });
          array1.push(newFence[0]);
        });
        let array2 = array1.map(function (elem) {
          return elem.styleMinProfit;
        });

        let styleMax = Math.max(...array2);
        let accountMax = this.extraPanelData["minProfit"];
        this.minProfit = Math.max(styleMax, accountMax);
      }
    },
  },
  methods: {
    getStyleImage(style) {
      return this.multiFences.find((x) => x.styleOfFence == style).styleImage;
    },
    sendLoad() {
      var self = this;
      this.getRemovalForCategory();
      this.$emit("loadingYes");
      setTimeout(function () {
        self.generatePDF();
      }, 200);
    },

    getRemovalForCategory() {
      this.remvoalForCategory = 0;

      if (this.removalCategory != null) {
        this.removalForCategory = this.removalDbSource[this.removalCategory];
      }
    },
    pdfUploadToCRM(doc) {
      var docdown = doc;
      var self = this;

      self.downloadPDF(docdown);
    },

    generatePDF() {
      // ========================== push fence ======================= //

      let ourOfferBodyData = [];
      let detailPrice = [];
      let extraPrice = [];
      let labor = [];
      let fenceInfoBody = [];

      this.materialPrice = 0;
      this.totalMaterialPrice = 0;
      this.standardLaborCharges = 0;
      this.totalLabor = 0;
      this.grandTotal = 0;
      this.profitPrice = 0;

      // start for loop for multipleStyles
      for (let index = 0; index < this.multiFences.length; index++) {
        this.datAcategoryOfFence = null;
        this.datAstyleOfFence = null;
        this.datAheightOfFence = null;
        this.datAcolorOfFence = null;
        this.datAgateStyle = null;
        this.datAgateWidth = null;
        this.datAlengths = [];
        this.datAlaborForGate = null;
        this.datAamountOfRemoval = null;
        this.datAgates = [];
        this.datAamountOfCorners = null;
        this.datAcapStyle = null;
        this.datAcornersArray = [];
        this.datAfeetFromZero = null;
        this.datAamountOfHoles = null;

        this.datAcategoryOfFence = this.multiFences[index]["categoryOfFence"];
        this.datAstyleOfFence = this.multiFences[index]["styleOfFence"];
        this.datAheightOfFence = this.multiFences[index]["heightOfFence"];
        this.datAcolorOfFence = this.multiFences[index]["colorOfFence"];
        this.datAgateStyle = this.multiFences[index]["gateStyle"];
        this.datAgateWidth = this.multiFences[index]["gateWidth"];
        this.datAlengths = this.multiFences[index]["lengths"];
        this.datAlaborForGate = this.multiFences[index]["laborForGate"];
        this.datAamountOfRemoval = this.multiFences[index]["amountOfRemoval"];
        this.datAgates = this.multiFences[index]["gates"];
        this.datAamountOfCorners = this.multiFences[index]["amountOfCorners"];
        this.datAcapStyle = this.multiFences[index]["capStyle"];
        this.datAcornersArray = this.multiFences[index]["cornersArray"];
        this.datAfeetFromZero = this.multiFences[index]["feetFromZero"];
        this.datAamountOfHoles = this.multiFences[index]["amountOfHoles"];

        // ============================== calculator ======================== //

        // this.profitPrice = this.minProfit;

        // geting category of fence
        var categoryOfFence = this.datAcategoryOfFence;

        // Getting PanelRetail
        var panelRetail = this.fenceStyleForPanelRetail;
        // Getting PanelCost
        var panelCost = this.fenceStyleForPanelCost;

        // Getting heightOfFence
        var heightOfFence = this.datAheightOfFence;

        // Getting gateStyle
        var gateStyle = this.datAgateStyle;
        var ifGateStyle;

        if (gateStyle == "Gate") {
          ifGateStyle = "0";
        } else {
          ifGateStyle = this.datAgates.length;
        }
        // Getting number of end posts END

        // Getting gateStyleRetail
        var gateStyleRetail = this.fenceStyleForGatePrice;

        // Getting number of end posts START
        let lengthNumber = this.datAlengths.length;
        // Getting number of end posts END

        // Getting number of regular posts or "line posts" START
        let postSpacing = this.fenceStyleForPostSpacing[0];
        let filteredForRightLengths = this.datAlengths.filter(
          (element) => (element * 12) / postSpacing >= 1
        );
        let filteredForPosts = filteredForRightLengths.map(
          (element) => (element * 12) / postSpacing
        );
        let arrayOfPosts = filteredForPosts.map((element) =>
          Math.ceil(element)
        );
        // Getting number of regular posts or "line posts" END

        // Getting number of panels that needs 0 line posts but exactly 1 panel START
        var exactlyOnePanel = 0;
        filteredForPosts.forEach(function (element) {
          if (element == 1) {
            exactlyOnePanel += 1;
          }
        });
        //sdfsafsa
        // Getting number of panels that needs 0 line posts but exactly 1 panel END

        // Getting number of regular panels START
        let arrayOfPanelCount = filteredForPosts.map((element) =>
          Math.floor(element)
        );

        if (arrayOfPanelCount.length >= 1) {
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          var panelCount = arrayOfPanelCount.reduce(reducer);
          panelCount =
            arrayOfPanelCount.reduce(reducer) -
            this.datAamountOfCorners -
            this.endPosts;
        } else {
          var panelCount = 0;
        }
        // Getting number of regular panels END

        // Getting the lengths of "cut panels" START

        // Getting the lengths of "cut panels" from small cuts START
        let filteredForCutLengths = this.datAlengths.filter(
          (element) => (element * 12) / postSpacing < 1
        );
        let filteredForCuts = filteredForCutLengths.map(
          (element) => element * 12
        );
        // Getting the lengths of "cut panels" from small cuts End

        // Getting the lengths of "cut panels" from big cuts START
        let filteredForCutLengthsOfBigger = this.datAlengths.filter(
          (element) => (element * 12) / postSpacing > 1
        );
        let filteredForCutsOfBigger = filteredForCutLengthsOfBigger.map(
          (element) => element * 12
        );
        // inches of big cuts /\

        // divide that by spacing
        // minus whole number times spacing from inches of big cut

        let filteredDownBiggerForCuts = filteredForCutsOfBigger.map(function (
          element
        ) {
          var fenceLengthMaker = element / postSpacing;
          var fenceLengthMakerDown = Math.floor(fenceLengthMaker);
          var lengthToMinus = (fenceLengthMaker - fenceLengthMakerDown).toFixed(
            2
          );
          var finalReturn = (lengthToMinus * postSpacing).toFixed(2);
          return finalReturn;
        });

        var extraCutsArrayToAdd = filteredDownBiggerForCuts.map((element) =>
          element.toString().slice(0, 5)
        );
        var filteredForCutsLengths = [];
        var arrayToInsert = [];
        filteredForCutsLengths = filteredForCuts.map((element) =>
          element.toString().slice(0, 5)
        );
        arrayToInsert = filteredForCutsLengths.map(
          (element) => " " + element + '"'
        );
        extraCutsArrayToAdd.forEach((element) =>
          arrayToInsert.push(" " + element + '"')
        );
        // Getting the lengths of "cut panels" END
        var extraCutsPriceArray = [];
        extraCutsPriceArray =
          filteredForCutsLengths.concat(extraCutsArrayToAdd);
        var extraCutsPriceArrayNum = extraCutsPriceArray.map((element) =>
          parseFloat(element)
        );
        extraCutsPriceArrayNum = extraCutsPriceArrayNum.filter(
          (element) => element != 0
        );

        var integerReduce = [];
        if (extraCutsPriceArrayNum.length >= 1) {
          // Amount of extra panels needed
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          integerReduce = extraCutsPriceArrayNum.reduce(reducer);
        } else {
        }

        //Knapsack Problem START
        var postSpacingForKnapsack = this.fenceStyleForPostSpacing[0] - 12;

        extraCutsPriceArrayNum.forEach(function (element, index) {
          var i = index;
          if (index < extraCutsPriceArrayNum.length - 1) {
            // iterate over not just the next element but all of the elements in an array //
            i += 1;
            var nextValue = extraCutsPriceArrayNum[i];
            if (element + nextValue < postSpacingForKnapsack) {
              var newValue = element + nextValue;
              var removeValFromIndex = [index, i];
              for (var a = removeValFromIndex.length - 1; a >= 0; a--)
                extraCutsPriceArrayNum.splice(removeValFromIndex[a], 1);
              extraCutsPriceArrayNum.splice(0, 0, newValue);
            } else if (element + nextValue > postSpacingForKnapsack) {
              i += 1;
              var nextNextValue = extraCutsPriceArrayNum[i];
              if (element + nextNextValue < postSpacingForKnapsack) {
                var newValue = element + nextNextValue;
                var removeValFromIndex = [index, i];
                for (var a = removeValFromIndex.length - 1; a >= 0; a--)
                  extraCutsPriceArrayNum.splice(removeValFromIndex[a], 1);
                extraCutsPriceArrayNum.splice(0, 0, newValue);
              } else {
              }
              //embed above if statement
            }
          }
        });

        extraCutsPriceArrayNum.forEach(function (element, index) {
          var i = index;
          if (index < extraCutsPriceArrayNum.length - 1) {
            // iterate over not just the next element but all of the elements in an array //
            i += 1;
            var nextValue = extraCutsPriceArrayNum[i];
            if (element + nextValue < postSpacingForKnapsack) {
              var newValue = element + nextValue;
              var removeValFromIndex = [index, i];
              for (var a = removeValFromIndex.length - 1; a >= 0; a--)
                extraCutsPriceArrayNum.splice(removeValFromIndex[a], 1);
              extraCutsPriceArrayNum.splice(0, 0, newValue);
            } else if (element + nextValue > postSpacingForKnapsack) {
              i += 1;
              var nextNextValue = extraCutsPriceArrayNum[i];
              if (element + nextNextValue < postSpacingForKnapsack) {
                var newValue = element + nextNextValue;
                var removeValFromIndex = [index, i];
                for (var a = removeValFromIndex.length - 1; a >= 0; a--)
                  extraCutsPriceArrayNum.splice(removeValFromIndex[a], 1);
                extraCutsPriceArrayNum.splice(0, 0, newValue);
              } else {
              }
              //embed above if statement
            }
          }
        });

        var extraCutsAmount;
        //Knapsack Problem END
        if (extraCutsPriceArrayNum.length >= 1) {
          extraCutsAmount = extraCutsPriceArrayNum.length;
        } else {
          extraCutsAmount = 0;
        }
        // var extraCutsAmount = Math.ceil(integerReduce / (parseFloat(this.fenceStyleForPostSpacing) - 12));
        if (arrayOfPosts.length >= 1) {
          // var linePosts = arrayOfPosts.reduce(reducer) - this.datAamountOfCorners - this.endPosts + 1;
          var linePosts =
            panelCount +
            this.endPosts +
            this.datAamountOfCorners -
            exactlyOnePanel;
        } else {
          var linePosts = 0;
        }

        var linePostRetail = (
          linePosts * this.fenceStyleForRegularPostRetail
        ).toFixed(2);
        var linePostOurCost = (
          linePosts * this.fenceStyleForRegularPostOurCost
        ).toFixed(2);

        // Getting total price for cut lengths Retail START
        if (extraCutsPriceArrayNum.length >= 1) {
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          var cutPanelTotalCost = extraCutsPriceArrayNum.reduce(reducer);
          var cutPanelTotalCostReduced = cutPanelTotalCost / postSpacing;
          var cutPanelAmount = Math.ceil(cutPanelTotalCostReduced);
          var retailofCutPanels = cutPanelAmount * panelRetail;
        } else {
          var retailofCutPanels = 0;
        }

        // Getting total price for cut lengths Our Cost START
        if (extraCutsPriceArrayNum.length >= 1) {
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          var cutPanelTotalCost = extraCutsPriceArrayNum.reduce(reducer);
          var cutPanelTotalCostReduced = cutPanelTotalCost / postSpacing;
          var cutPanelAmount = Math.ceil(cutPanelTotalCostReduced);
          var ourCostofCutPanels =
            cutPanelAmount * this.fenceStyleForPanelOurCost;
        } else {
          var ourCostofCutPanels = 0;
        }

        var panelRetailPrice =
          (panelCount +
            this.endPosts +
            this.datAamountOfCorners +
            extraCutsAmount) *
          this.fenceStyleForPanelRetail;
        var panelCostPrice =
          (panelCount + this.endPosts + this.datAamountOfCorners) * panelCost;

        var endPostFinalRetail =
          this.endPosts * this.fenceStyleForEndPostRetail;
        var endPostOurCost = this.endPosts * this.fenceStyleForEndPostOurCost;

        var prp = parseFloat(panelRetailPrice);
        var epfr = parseFloat(endPostFinalRetail);
        var lpr = parseFloat(linePostRetail);

        var pcp = parseFloat(panelCostPrice);
        var epoc = parseFloat(endPostOurCost);
        var lpoc = parseFloat(linePostOurCost);

        this.linePosts = linePosts;

        var retailTotalBefore =
          prp +
          this.gateFinalRetail +
          epfr +
          lpr +
          this.cornerRetailFinal +
          this.capRetailFinal;

        var costTotalBefore =
          pcp +
          this.gateFinalCost +
          epoc +
          lpoc +
          this.cornerOurCostFinal +
          this.capRetailOurCost;

        var ourOfferTotalAfterMaterials =
          costTotalBefore + extraCutsAmount * this.fenceStyleForPanelOurCost;

        // getting standardLaborCharges
        var standardLaborCharges = parseFloat(
          (this.endPosts + linePosts + parseFloat(this.datAamountOfCorners)) *
            this.laborCostForStyle +
            this.laborCostForGate
        );

        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        let totallength = this.datAlengths.reduce(reducer);
        localStorage.setItem('footage', JSON.stringify(totallength));

        let [month, date, year] = new Date().toLocaleDateString().split("/");

        let tempDetailPrice = [
          [
            panelCount + this.endPosts + this.datAamountOfCorners,
            this.datAstyleOfFence,
            this.datAheightOfFence + '"',
            this.datAcolorOfFence,
            "$" + panelCostPrice.toFixed(2),
          ],
          [
            ifGateStyle,
            "Gate(s): " + this.datAgates + " (" + this.datAstyleOfFence + ")",
            "",
            this.datAcolorOfFence,
            "$" + this.gateFinalOurCost,
          ],
          [
            extraCutsAmount,
            "Cut " + this.datAstyleOfFence + ":: Lengths:",
            this.datAheightOfFence + '"',
            this.datAcolorOfFence,
            "$0.00",
          ],
          [, arrayToInsert, , ,],
          [
            this.endPosts,
            "End Posts " + "(" + this.datAstyleOfFence + ")",
            "",
            this.datAcolorOfFence,
            "$" + endPostOurCost.toFixed(2),
          ],
          [
            linePosts,
            "Line Posts " + "(" + this.datAstyleOfFence + ")",
            "",
            this.datAcolorOfFence,
            "$" + linePostOurCost,
          ],
          [
            this.datAamountOfCorners,
            "Corner Posts " + "(" + this.datAstyleOfFence + ")",
            "",
            this.datAcolorOfFence,
            "$" + this.cornerOurCostFinal.toFixed(2),
          ],
          [
            this.amountOfHeavyDutyPosts,
            "Heavy Duty Posts " + "(" + this.datAstyleOfFence + ")",
            "",
            this.datAcolorOfFence,
            "$" + this.amountOfHeavyDutyPostsOurCost.toFixed(2),
          ],
          [
            this.capQty,
            "Cap Style " + "(" + this.datAcapStyle + ")",
            "",
            this.datAcolorOfFence,
            "$" + this.capRetailOurCost.toFixed(2),
          ],
        ];
        detailPrice = detailPrice.concat(tempDetailPrice);

        let tempExtraPrice = [
          [
            extraCutsAmount,
            "Extra Panels For Cuts" + " (" + this.datAstyleOfFence + ")",
            this.datAheightOfFence + '"',
            this.datAcolorOfFence,
            "$" + (extraCutsAmount * this.fenceStyleForPanelOurCost).toFixed(2),
          ],
        ];
        extraPrice = extraPrice.concat(tempExtraPrice);

        let tempLabor = [
          [
            "",
            "Standard Labor Charges ",
            "",
            "( " +
              (this.endPosts +
                linePosts +
                parseFloat(this.datAamountOfCorners) +
                parseFloat(this.amountOfHeavyDutyPosts)) +
              " posts: " +
              this.datAcategoryOfFence +
              " )",
            "$" + standardLaborCharges.toFixed(2),
          ],
          // ourCostofCutPanels ...];
        ];
        labor = labor.concat(tempLabor);

        let tempFenceInfoBody = [
          [
            {
              content: this.datAstyleOfFence,
              styles: {
                fontStyle: "bold",
                fontSize: "0",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.datAstyleOfFence,
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.datAheightOfFence + '"',
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.datAcolorOfFence,
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.datAgates.length,
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: totallength + "'",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
          ],
        ];
        fenceInfoBody = fenceInfoBody.concat(tempFenceInfoBody);

        // counting price
        this.materialPrice += costTotalBefore;
        this.totalMaterialPrice += ourOfferTotalAfterMaterials;
        this.standardLaborCharges += standardLaborCharges;
      }
      // end for loop for multipleStyles

      // discount
      var discountPercentArray = this.fenceCapStyle.filter(
        (element) => element.discount
      );
      var discountObject = discountPercentArray.filter(
        (element) =>
          retailTotalBefore >= element.min && retailTotalBefore < element.max
      );
      var retailTotalDifferenceDiscount =
        retailTotalBefore -
        (retailTotalBefore.toFixed(2) -
          retailTotalBefore.toFixed(2) * (discountObject[0].discount / 100));
      // var retailTotalAfterDiscount =
      //   retailTotalBefore.toFixed(2) -
      //   retailTotalBefore.toFixed(2) * (discountObject[0].discount / 100);

      var retailTotalAfterDiscount = retailTotalBefore.toFixed(2);

      // Getting total price for cut lengths END retailTotalDifferenceDiscount
      var amountOfHardHoles = parseFloat(this.amountOfHoles * this.hardHole);
      var amountOfRemovalRetail = parseFloat(
        this.amountOfRemoval * this.removalForCategory
      );

      var totalLaborCharges =
        amountOfRemovalRetail + this.standardLaborCharges + amountOfHardHoles;

      this.totalLabor = totalLaborCharges;
      this.grandTotal = Number(
        parseFloat(this.totalMaterialPrice) + parseFloat(this.totalLabor)
      );

      var clientRetail = (
        parseFloat(retailTotalAfterDiscount) + parseFloat(totalLaborCharges)
      ).toFixed(2);

      var totalLaborChargesRetail = totalLaborCharges;

      var profit = parseFloat(
        (
          clientRetail -
          (parseFloat(this.totalMaterialPrice) + parseFloat(totalLaborCharges))
        ).toFixed(2)
      );

      if (profit < this.minProfit) {
        totalLaborChargesRetail = (
          totalLaborCharges +
          this.minProfit -
          (retailTotalAfterDiscount - this.totalMaterialPrice.toFixed(2))
        ).toFixed(2);
        clientRetail = (
          parseFloat(retailTotalAfterDiscount) +
          parseFloat(totalLaborChargesRetail)
        ).toFixed(2);

        profit = parseFloat(
          (
            clientRetail -
            (parseFloat(this.totalMaterialPrice) +
              parseFloat(totalLaborCharges))
          ).toFixed(2)
        );
      }
      this.profitPrice = profit;
      localStorage.setItem('price', JSON.stringify(Math.ceil(this.grandTotal + this.profitPrice)));
      localStorage.setItem('priceRange', Math.ceil(
                    (this.grandTotal + this.profitPrice) * 1
                  ).toString() +
                  " ~ " +
                  Math.ceil(
                    (this.grandTotal + this.profitPrice) * 1.1
                  ).toString());

      let hardHoleTr = [["", "Hard Holes", "", "", "$" + amountOfHardHoles]];

      let removalTr = [["", "Removal", "", "", "$" + amountOfRemovalRetail]];

      let materialCharges = [
        [
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "Material Charges:",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content:
              "$" +
              this.materialPrice.toFixed(2) /*+ costTotalBefore.toFixed(2)*/,
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
        ],
      ];
      let totalMaterial = [
        [
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "Total Material Charges:",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content:
              "$" +
              this.totalMaterialPrice.toFixed(
                2
              ) /*+ ourOfferTotalAfterMaterials.toFixed(2)*/,
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
        ],
      ];
      let totalLabor = [
        [
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "Total Labor Charges:",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "$" + this.totalLabor.toFixed(2) /* + totalLaborCharges*/,
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
        ],
      ];
      let grandTotal = [
        [
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "Total",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "$" + Number(this.grandTotal).toFixed(2) /*+
            (
              parseFloat(ourOfferTotalAfterMaterials) +
              parseFloat(totalLaborCharges)
            ).toFixed(2)*/,
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
        ],
      ];
      let profitPrice = [
        [
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "Additional profit",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "$" + this.profitPrice.toFixed(2) /*+ profit.toFixed(2)*/,
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
        ],
      ];

      let realGrandTotal = [
        [
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "Grand Total",
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "$" + (this.grandTotal + this.profitPrice).toFixed(2) /*+ profit.toFixed(2)*/,
            styles: {
              fontStyle: "bold",
              fontSize: "12",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
        ],
      ];

      ourOfferBodyData = ourOfferBodyData.concat(detailPrice);
      ourOfferBodyData = ourOfferBodyData.concat(materialCharges);
      ourOfferBodyData = ourOfferBodyData.concat(extraPrice);
      ourOfferBodyData = ourOfferBodyData.concat(totalMaterial);
      ourOfferBodyData = ourOfferBodyData.concat(labor);
      ourOfferBodyData = ourOfferBodyData.concat(removalTr);
      ourOfferBodyData = ourOfferBodyData.concat(hardHoleTr);
      ourOfferBodyData = ourOfferBodyData.concat(totalLabor);
      ourOfferBodyData = ourOfferBodyData.concat(grandTotal);
      ourOfferBodyData = ourOfferBodyData.concat(profitPrice);
      ourOfferBodyData = ourOfferBodyData.concat(realGrandTotal);

      let [month, date, year] = new Date().toLocaleDateString().split("/");

      // =================================== generate pdf =========================== //

      // DOC FOR DOWNLOAD AND UPLOAD TO DB
      let doc = new jsPDF("p", "mm");

      // pg1
      doc.addImage(this.header, 0, 0, 65, 90);
      doc.addImage(this.headerone, 65, 0, 145, 17);

      doc.autoTable({
        margin: { top: 20, left: 70 },
        headStyles: { fontStyle: "bold" },
        body: [
          [
            {
              content: "Name: ",
              styles: {
                fontStyle: "bold",
                fontSize: "10",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content:
                this.userData[0].firstName + " " + this.userData[0].lastName,
              styles: {
                fontStyle: "normal",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
          ],
          [
            {
              content: "Address: ",
              styles: {
                fontStyle: "bold",
                fontSize: "10",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.userData[0].homeAddress,
              styles: {
                fontStyle: "normal",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
          ],
          [
            {
              content: "Date: ",
              styles: {
                fontStyle: "bold",
                fontSize: "10",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: month + "/" + date + "/" + year,
              styles: {
                fontStyle: "normal",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
          ],
          [
            {
              content: "Email: ",
              styles: {
                fontStyle: "bold",
                fontSize: "10",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.userData[0].emailAddress,
              styles: {
                fontStyle: "normal",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
          ],
          [
            {
              content: "Phone: ",
              styles: {
                fontStyle: "bold",
                fontSize: "10",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.userData[0].phoneNumber,
              styles: {
                fontStyle: "normal",
                fontSize: "12",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: "",
              styles: {
                fontStyle: "bold",
                fontSize: "12",
                textColor: [255, 255, 255],
                fillColor: [255, 255, 255],
              },
            },
          ],
        ],
      }),
        doc.autoTable({
          margin: { left: 70 },
          headStyles: { fontStyle: "bold" },
          body: [
            [
              {
                content: "Please note that layouts under 100 feet may not be accurate.",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "normal",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
            ],
            [
              {
                content: "Price is based on a clean and clear fence line.",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "normal",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
            ],
            [
              {
                content: "Gates (if any) are not arched or sloped.",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "normal",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
            ],
          ],
        }),
        doc.autoTable({
          margin: { top: 95 },
          headStyles: { fontStyle: "bold" },
          body: [
            [
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "18",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
            ],
            [
              {
                content: "Fence Information",
                styles: {
                  fontStyle: "bold",
                  fontSize: "18",
                  textColor: [0, 0, 0],
                  fillColor: [21, 181, 229],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [21, 181, 229],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [21, 181, 229],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [21, 181, 229],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [21, 181, 229],
                },
              },
            ],
          ],
        });

      // doc.addImage(this.fencePhoto,40,110,35,30);
      doc.autoTable({
        willDrawCell: function (HookData) {
          if (HookData.cell.text == "GATES: 0") {
            /*&& HookData.column.index === 0) */ HookData.cell.text = "";
          }
          if (HookData.cell.text == "Footage: 0'") {
            /*&& HookData.column.index === 0) */ HookData.cell.text = "";
          }
        },
        didDrawCell: (data) => {
          if (data.section === "body" && data.column.index === 0) {
            let styleImage = this.getStyleImage(data.cell.text);
            doc.addImage(styleImage, data.cell.x + 2, data.cell.y + 2, 10, 10);
          }
        },
        margin: { top: 110 },
        headStyles: {
          fontStyle: "bold",
          fillColor: "white",
          textColor: "blue",
          borderColor: "black",
          borderWidth: 1,
        },
        head: [["Img", "Style", "Height", "Color", "Gate", "Footage"]],
        body: fenceInfoBody,
      }),
        doc.autoTable({
          willDrawCell: function (HookData) {
            if (
              HookData.cell.text == "$0.00" ||
              HookData.cell.text == "$0" ||
              HookData.cell.text == "0"
            ) {
              /*&& HookData.column.index === 0) */ HookData.cell.styles.textColor =
                HookData.cell.styles.fillColor;
              HookData.row.height = 0;
              HookData.row.maxCellHeight = 0;
            }
          },
          margin: { top: 100 },
          headStyles: { fontStyle: "bold" },
          body: [
            [
              {
                content: "Estimated Project Cost",
                styles: {
                  fontStyle: "bold",
                  fontSize: "18",
                  textColor: [0, 0, 0],
                  fillColor: [21, 181, 229],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [21, 181, 229],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [21, 181, 229],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [21, 181, 229],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [21, 181, 229],
                },
              },
            ],
          ],
        }),
        doc.autoTable({
          willDrawCell: function (HookData) {
            if (
              HookData.cell.text == "Removal: $0" ||
              HookData.cell.text == "Hard Holes: $0" ||
              HookData.cell.text == "0"
            ) {
              /*&& HookData.column.index === 0) */ HookData.cell.styles.textColor =
                HookData.cell.styles.fillColor;
              HookData.row.height = 0;
              HookData.row.maxCellHeight = 0;
            }
          },
          margin: { top: 110 },
          headStyles: { fontStyle: "bold" },
          body: [
            [
              {
                content:
                  "Grand Total:  ± $" +
                  Math.ceil(this.grandTotal + this.profitPrice),
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [255, 255, 255],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
              {
                content: "",
                styles: {
                  fontStyle: "bold",
                  fontSize: "12",
                  textColor: [0, 0, 0],
                  fillColor: [255, 255, 255],
                },
              },
            ],
          ],
        }),
        // pg 2
        doc.addPage();
      var heightforphoto = (200 / this.output.width) * this.output.height;

      if (this.isMobile == true) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const marginX = (pageWidth - 100) / 2;

        if (this.isTablet == true) {
          doc.addImage(this.output, 5, 5, 200, heightforphoto);
        } else {
          doc.addImage(this.output, marginX, 5, 100, 200);
        }
      } else {
        doc.addImage(this.output, 5, 5, 200, heightforphoto);
      }
      doc.addPage();

      // pg 3
      doc.text("Our Offer", 10, 10);
      doc.autoTable({
        willDrawCell: function (HookData) {
          if (HookData.cell.text == "0") {
            /*&& HookData.column.index === 0) */ HookData.cell.styles.textColor =
              HookData.cell.styles.fillColor;
            HookData.row.height = 0;
            HookData.row.maxCellHeight = 0;
          }
          if (HookData.cell.text == "$0" && HookData.row.raw[1] == "Removal") {
            HookData.cell.styles.textColor = HookData.cell.styles.fillColor;
            HookData.row.height = 0;
            HookData.row.maxCellHeight = 0;
          }
          if (
            HookData.cell.text == "$0" &&
            HookData.row.raw[1] == "Hard Holes"
          ) {
            HookData.cell.styles.textColor = HookData.cell.styles.fillColor;
            HookData.row.height = 0;
            HookData.row.maxCellHeight = 0;
          }
        },
        headStyles: { fontStyle: "bold" },
        head: [["Qnt.", "Description", "Height", "Color", "Price   "]],
        body: ourOfferBodyData,
      });

      this.pdfUploadToCRM(doc);
    },

    downloadPDF(docdown) {
      let output = docdown.output();
      let encoded = btoa(output);

      this.$emit("pdfResponse", docdown.output('blob'));
      docdown.save("FenceProSolutionsEstimate.pdf");
      this.$emit("loadingNo");
    },
  },
  computed: {
    laborCostForStyle: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;

      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      return filteredForHeight[0]["styleLabor"];
    },
    laborCostForGate: function () {
      if (this.datAgates.length > 0) {
        let gates = this.datAgates;
        let laborForGate = this.datAlaborForGate;
        let retail = gates.map((element) => laborForGate[element]);

        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        return retail.reduce(reducer);
      }
      return 0;
    },
    endPosts: function () {
      var endPosts;
      if (this.datAcategoryOfFence == "Aluminum") {
        endPosts =
          this.datAcornersArray.length -
          this.datAamountOfCorners +
          this.datAgates.length -
          this.datAfeetFromZero;
      } else {
        endPosts =
          this.datAcornersArray.length -
          this.datAamountOfCorners +
          this.datAgates.length * 2 -
          this.datAfeetFromZero;
      }
      return endPosts;
    },
    gateFinalRetail: function () {
      if (this.datAgates.length >= 1) {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        var gateStyle = this.datAgateStyle + " Retail";

        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );

        let gates = this.datAgates;
        let gates2 = gates.map((element) => element + " Retail");
        let retail = gates2.map((element) => filteredForHeight[0][element]);
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        let retailTotal = retail.reduce(reducer);
        return retailTotal;
      } else {
        return 0;
      }
    },
    gateFinalOurCost: function () {
      if (this.datAgates.length >= 1) {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        var gateStyle = this.datAgateStyle + " Retail";
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        let gates = this.datAgates;
        let gates2 = gates.map((element) => element + " Our Cost");
        let retail = gates2.map((element) => filteredForHeight[0][element]);
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        let retailTotal = retail.reduce(reducer);
        return retailTotal;
      } else {
        return 0;
      }
    },
    gateFinalCost: function () {
      if (this.datAgates.length >= 1) {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        var gateStyle = this.datAgateStyle + " Retail";
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        let gates = this.datAgates;
        let gates2 = gates.map((element) => element + " Our Cost");
        let retail = gates2.map((element) => filteredForHeight[0][element]);
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        let retailTotal = retail.reduce(reducer);
        return retailTotal;
      } else {
        return 0;
      }
    },
    // Setting the data for Post Spacing from Pricing Data
    fenceStyleForPostSpacing: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Spacing between posts"]
      );
      return filteredDone;
    },
    // Setting the data for Regular Post Retail Pricing from Pricing Data
    fenceStyleForRegularPostRetail: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Regular Posts Retail"]
      );
      return filteredDone;
    },
    // Setting the data for Regular Post Our Cost Pricing from Pricing Data
    fenceStyleForRegularPostOurCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Regular Post Our Cost"]
      );
      return filteredDone;
    },
    // Setting the data for EndPostsRetail from Pricing Data
    fenceStyleForEndPostRetail: function () {
      var filteredDone;
      if (this.datAcategoryOfFence == "Chain Link") {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        filteredDone = filteredForHeight.map(
          (element) => element["End Posts Retail"]
        );
      } else {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        filteredDone = filteredForHeight.map(
          (element) => element["Regular Posts Retail"]
        );
      }
      return filteredDone;
    },
    // Setting the data for EndPostsOurCost from Pricing Data
    fenceStyleForEndPostOurCost: function () {
      var filteredDone;
      if (this.datAcategoryOfFence == "Chain Link") {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        filteredDone = filteredForHeight.map(
          (element) => element["End Posts Our Cost"]
        );
      } else {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        filteredDone = filteredForHeight.map(
          (element) => element["Regular Post Our Cost"]
        );
      }
      return filteredDone;
    },
    // Setting the data for CornerPostRetail from Pricing Data
    fenceStyleForCornerPostRetail: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Corner Posts Retail"]
      );
      return filteredDone;
    },
    // Setting the data for CornerPostOurCost from Pricing Data
    fenceStyleForCornerPostOurCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Corner Post Our Cost"]
      );
      return filteredDone;
    },
    amountOfHeavyDutyPostsRetail: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Heavy Duty End Post Retail"]
      );
      var retail;
      if (this.datAcategoryOfFence == "Aluminum") {
        retail = filteredDone[0];
      } else {
        retail = 0;
      }
      return parseFloat(retail) * parseFloat(this.amountOfHeavyDutyPosts);
    },
    amountOfHeavyDutyPostsOurCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Heavy Duty End Post Cost"]
      );
      var retail;
      if (this.datAcategoryOfFence == "Aluminum") {
        retail = filteredDone[0];
      } else {
        retail = 0;
      }
      return parseFloat(retail) * parseFloat(this.amountOfHeavyDutyPosts);
    },
    // Setting the data for panelRetail from Pricing Data
    fenceStyleForPanelRetail: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Panel Retail"]
      );
      return filteredDone;
    },
    // Setting the data for panelOurCost from Pricing Data
    fenceStyleForPanelOurCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Panel Our Cost"]
      );
      return filteredDone;
    },
    fenceStyleForPanelCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Panel Our Cost"]
      );
      return filteredDone;
    },
    fenceStyleForGatePrice: function () {
      // This Returns The Full Matched Set For The Fence
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      var gateStyle = this.datAgateStyle + " Retail";
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      // This Returns The Full Matched Set For The Fence
      let filteredDone = filteredForHeight.map((element) => element[gateStyle]);
      return filteredDone;
    },
    fenceStyleForCapRetail() {
      if (this.datAcapStyle != "Which Style Cap") {
        let filteredForCap = this.fenceCapStyle.filter(
          (element) => element["Cap Style"] == this.datAcapStyle
        );
        return filteredForCap[0].Retail;
      }
      return 0;
    },
    fenceStyleForCapOurCost() {
      if (this.datAcapStyle != "Which Style Cap") {
        let filteredForCap = this.fenceCapStyle.filter(
          (element) => element["Cap Style"] == this.datAcapStyle
        );
        return filteredForCap[0].Cost;
      }
      return 0;
    },
    cornerRetailFinal() {
      var amount;
      if (
        this.datAcategoryOfFence == "Chain Link" &&
        this.datAamountOfCorners >= 1
      ) {
        amount = this.fenceStyleForCornerPostRetail * this.datAamountOfCorners;
      } else if (this.datAamountOfCorners >= 1) {
        amount = this.fenceStyleForRegularPostRetail * this.datAamountOfCorners;
      } else {
        amount = 0;
      }
      return amount;
    },
    cornerOurCostFinal() {
      var amount;
      if (
        this.datAcategoryOfFence == "Chain Link" &&
        this.datAamountOfCorners >= 1
      ) {
        amount = this.fenceStyleForCornerPostOurCost * this.datAamountOfCorners;
      } else if (this.datAamountOfCorners >= 1) {
        amount =
          this.fenceStyleForRegularPostOurCost * this.datAamountOfCorners;
      } else {
        amount = 0;
      }
      return amount;
    },
    capRetailFinal() {
      var amount = 0;
      if (this.datAcategoryOfFence == "Vinyl") {
        amount =
          this.fenceStyleForCapRetail *
          (this.endPosts +
            this.linePosts +
            parseFloat(this.datAamountOfCorners));
      }
      return amount;
    },
    capRetailOurCost() {
      var amount = 0;
      if (this.datAcategoryOfFence == "Vinyl") {
        amount =
          this.fenceStyleForCapOurCost *
          (this.endPosts +
            this.linePosts +
            parseFloat(this.datAamountOfCorners));
      }
      return amount;
    },
    capQty() {
      var amount;
      if (this.datAcategoryOfFence == "Vinyl") {
        amount =
          this.endPosts + this.linePosts + parseFloat(this.datAamountOfCorners);
      } else {
        amount = 0;
      }
      return amount;
    },
    amountOfHeavyDutyPosts() {
      var amount;
      if (this.datAcategoryOfFence == "Aluminum") {
        amount = this.datAgates.length;
      } else {
        amount = 0;
      }
      return amount;
    },
  },
};
</script>
